export default "__VITE_ASSET__DbQL6lmr__"